import { RiFolderLine } from '@remixicon/react';

import { IconComponent } from '@backstage/frontend-plugin-api';

import {
  IconBusiness,
  IconChartBar,
  IconChartLine,
  IconEvents,
  IconFlag,
  IconGridView,
  IconLab,
  IconStations,
  IconUser,
  RolloutIcon,
} from '@spotify/confidence-core-react';

export type Module =
  | 'metrics'
  | 'abtests'
  | 'rollouts'
  | 'flags'
  | 'segments'
  | 'events'
  | 'analysis'
  | 'insights'
  | 'surfaces'
  | 'initiatives'
  | 'collections';

export const ModuleIcons: Record<Module, IconComponent> = {
  metrics: IconChartLine,
  flags: IconFlag,
  abtests: IconLab,
  rollouts: RolloutIcon,
  events: IconEvents,
  analysis: IconChartBar,
  insights: IconStations,
  segments: IconUser,
  surfaces: IconGridView,
  initiatives: IconBusiness,
  collections: RiFolderLine as IconComponent,
};

export const workflowToIcon = (workflow: string): IconComponent => {
  switch (workflow) {
    default:
    case 'abest':
      return ModuleIcons.abtests;
    case 'rollout':
      return ModuleIcons.rollouts;
    case 'analysis':
      return ModuleIcons.analysis;
  }
};

export const resourceToIcon = (resource: string): IconComponent | undefined => {
  switch (resource) {
    case 'flag':
      return ModuleIcons.flags;
    case 'event':
      return ModuleIcons.events;
    case 'metric':
      return ModuleIcons.metrics;
    case 'abtest':
      return ModuleIcons.abtests;
    case 'rollout':
      return ModuleIcons.rollouts;
    case 'analysis':
      return ModuleIcons.analysis;
    default:
      return undefined;
  }
};
